#import "../ApprovalsListFields.graphql"
mutation ApprovalCreate($input: ApprovalCreateInput!) {
  approvalCreate(input: $input) {
    clientMutationId
    approval {
      ...ApprovalsListFields
    }
  }
}
